module.exports = __webpack_public_path__ + "static/img/12.42a8b46.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/eng/12.png
// module id = q9bO
// module chunks = 0